import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';
import type { TaxAndFeeInclusionPolicy } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/common.pb';

import STYLES from './TotalPriceSubtitle.module.scss';

import {
  isFeesIncludedPolicy,
  isTaxesFeesIncludedPolicy,
} from '@shared/utils-frontend/price-policy';

const cls = cssModules(STYLES);

type Props = {
  pricePerNight: number;
  taxAndFeeInclusionPolicy?: TaxAndFeeInclusionPolicy;
  i18n: I18nService;
};

const TotalPriceSubtitle = ({
  i18n: { formatCurrency, translate },
  pricePerNight,
  taxAndFeeInclusionPolicy,
}: Props) => {
  const travellerDailyPrice = formatCurrency(pricePerNight);

  const taxesFeesIncluded = isTaxesFeesIncludedPolicy(taxAndFeeInclusionPolicy);

  let label = '';
  if (taxesFeesIncluded) {
    label = translate('RoomRates_label_amountPerNight', {
      price_per_night: travellerDailyPrice,
    });
  } else if (isFeesIncludedPolicy(taxAndFeeInclusionPolicy)) {
    label = translate('PriceBreakDown_TotalItem_Excluding_Taxes_Only', {
      price: travellerDailyPrice,
    });
  } else {
    label = translate('PriceBreakDown_TotalItem_Excluding_Taxes', {
      price: travellerDailyPrice,
    });
  }

  return (
    <div
      className={cls(
        'TotalPriceSubtitle',
        !taxesFeesIncluded && 'TotalPriceSubtitle__alignStart',
      )}
    >
      <BpkText
        textStyle={TEXT_STYLES.footnote}
        color={TEXT_COLORS.textSecondary}
      >
        {label}
      </BpkText>
    </div>
  );
};

export default withI18n(TotalPriceSubtitle);
